// patrickrecommends — entry point. Compiled (with the CSS) by
// rollup-plugin-postcss to assets/built/index.js + .css.
//
// Implements:
//   1. Procedural SVG thumbs for posts without a feature_image
//      (deterministic gradient seeded by slug, four shape variants).
//   2. "Surprise me" — random redirect to one of the URLs rendered into
//      #pr-all-slugs by default.hbs. Binds to every .surprise button
//      so the masthead and the 404-page button both work.
//   3. As-you-type homepage search, using each row's data-* attributes.
//   4. Tag landing "often with" — counts co-occurring tags from the rows
//      currently rendered on the tag page.
//   5. 404 editorial note — picks one of the hidden <em data-note="…">
//      siblings at random and reveals it.

import "../css/index.css";

(function () {
    'use strict';

    function init() {
        // ── 1. Procedural SVG thumbs ──────────────────────────────────
        // Mirror of pr-thumb.jsx in the React design — same palette, same
        // hash, same four variants.
        var THUMB_PALETTE = [
            ['#2c3e50', '#506478'], ['#7d6b4a', '#a89472'],
            ['#3d4d3a', '#6b805f'], ['#6b3a3a', '#8e5a5a'],
            ['#3a4a6b', '#5e7099'], ['#6e5a3a', '#9a8559'],
            ['#4a4a4a', '#6e6e6e'], ['#5d4a3a', '#85705a'],
            ['#3a5d5a', '#5e8580'], ['#6b4a5d', '#8e6f82'],
            ['#5a5d3a', '#80855e'], ['#4a3a5d', '#6f5e85']
        ];
        function hash(s) {
            var h = 0;
            for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
            return Math.abs(h);
        }
        function svgEl(tag, attrs) {
            var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
            Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
            return el;
        }
        function buildThumb(seed) {
            var h = hash(seed);
            var pair = THUMB_PALETTE[h % THUMB_PALETTE.length];
            var bg = pair[0], fg = pair[1];
            var variant = (h >> 5) % 4;
            var id = 'g-' + seed.replace(/[^a-z0-9_-]/gi, '');

            var svg = svgEl('svg', { width: '56', height: '56', viewBox: '0 0 56 56' });
            var defs = svgEl('defs', {});
            var grad = svgEl('linearGradient', { id: id, x1: '0', y1: '0', x2: '1', y2: '1' });
            grad.appendChild(svgEl('stop', { offset: '0', 'stop-color': bg }));
            grad.appendChild(svgEl('stop', { offset: '1', 'stop-color': fg }));
            defs.appendChild(grad);
            svg.appendChild(defs);
            svg.appendChild(svgEl('rect', { width: '56', height: '56', fill: 'url(#' + id + ')' }));

            if (variant === 0) {
                svg.appendChild(svgEl('circle', { cx: '38', cy: '22', r: '14', fill: fg, opacity: '0.55' }));
            } else if (variant === 1) {
                svg.appendChild(svgEl('rect', { x: '0', y: '32', width: '56', height: '14', fill: fg, opacity: '0.6' }));
            } else if (variant === 2) {
                svg.appendChild(svgEl('rect', { x: '20', y: '6', width: '14', height: '50', fill: fg, opacity: '0.5' }));
            } else {
                svg.appendChild(svgEl('polygon', { points: '0,40 56,8 56,28 0,56', fill: fg, opacity: '0.5' }));
            }
            return svg;
        }
        document.querySelectorAll('.row-thumb-placeholder[data-seed]').forEach(function (el) {
            var seed = el.getAttribute('data-seed') || '';
            var svg = buildThumb(seed);
            el.replaceWith(svg);
        });

        // ── 2. Surprise me ─────────────────────────────────────────────
        var slugRoot = document.getElementById('pr-all-slugs');
        var urls = slugRoot
            ? Array.prototype.map.call(slugRoot.querySelectorAll('a'), function (a) { return a.getAttribute('href'); }).filter(Boolean)
            : [];
        var surpriseBtns = document.querySelectorAll('.surprise');
        surpriseBtns.forEach(function (btn) {
            if (urls.length) {
                btn.addEventListener('click', function () {
                    window.location.href = urls[Math.floor(Math.random() * urls.length)];
                });
            } else {
                btn.disabled = true;
                btn.style.opacity = '0.4';
            }
        });

        // ── 3. As-you-type search ──────────────────────────────────────
        var searchInput = document.getElementById('pr-search');
        var feed = document.getElementById('pr-feed');
        var emptyEl = document.getElementById('pr-empty');
        if (searchInput && feed) {
            var rows = Array.prototype.slice.call(feed.querySelectorAll('.row'));
            var index = rows.map(function (row) {
                return [
                    row,
                    (
                        (row.getAttribute('data-title') || '') + ' ' +
                        (row.getAttribute('data-tags') || '') + ' ' +
                        (row.querySelector('.row-blurb') ? row.querySelector('.row-blurb').textContent : '')
                    ).toLowerCase()
                ];
            });
            var update = function () {
                var q = searchInput.value.trim().toLowerCase();
                var visible = 0;
                index.forEach(function (entry) {
                    var match = !q || entry[1].indexOf(q) !== -1;
                    entry[0].style.display = match ? '' : 'none';
                    if (match) visible++;
                });
                if (emptyEl) emptyEl.hidden = visible !== 0;
            };
            searchInput.addEventListener('input', update);
        }

        // ── 4. Tag landing: related ("often with") tags ────────────────
        var related = document.getElementById('pr-related');
        if (related && feed) {
            var path = window.location.pathname.replace(/\/$/, '').split('/');
            var currentTag = decodeURIComponent(path[path.length - 1] || '').toLowerCase();
            var counts = {};
            feed.querySelectorAll('.row').forEach(function (row) {
                (row.getAttribute('data-tags') || '').split(',').forEach(function (raw) {
                    var name = raw.trim();
                    if (!name) return;
                    var key = name.toLowerCase().replace(/\s+/g, '-');
                    if (key === currentTag) return;
                    if (!counts[name]) counts[name] = 0;
                    counts[name]++;
                });
            });
            var entries = Object.keys(counts).map(function (k) { return [k, counts[k]]; });
            entries.sort(function (a, b) { return b[1] - a[1]; });
            if (entries.length === 0) {
                related.style.display = 'none';
            } else {
                entries.slice(0, 8).forEach(function (e) {
                    var a = document.createElement('a');
                    a.className = 'tag';
                    a.href = '/tag/' + encodeURIComponent(e[0].toLowerCase().replace(/\s+/g, '-')) + '/';
                    a.textContent = e[0] + ' · ' + e[1];
                    related.appendChild(a);
                });
            }
        }

        // ── 5. Photo lightbox ──────────────────────────────────────────
        // Collect gallery + content + hero images from the post body and
        // wire each one to open a full-screen modal with prev/next nav.
        var postBody = document.querySelector('.post-body');
        var hero = document.querySelector('.post-hero');
        var photos = [];
        function collectFrom(root) {
            if (!root) return;
            // Gallery images first (preserve gallery order), then standalone
            // image cards and any other figure-wrapped images.
            var nodes = root.querySelectorAll(
                '.kg-gallery-image img, .kg-image-card img, figure > img'
            );
            nodes.forEach(function (img) {
                // Skip images that are already inside a link — let the link win.
                if (img.closest('a')) return;
                photos.push(img);
            });
        }
        if (hero) {
            var heroImg = hero.querySelector('img');
            if (heroImg && !heroImg.closest('a')) photos.push(heroImg);
        }
        collectFrom(postBody);
        if (photos.length) {
            // Largest URL from srcset, else src.
            function fullSrc(img) {
                var srcset = img.getAttribute('srcset');
                if (srcset) {
                    var best = null, bestW = 0;
                    srcset.split(',').forEach(function (part) {
                        var bits = part.trim().split(/\s+/);
                        var url = bits[0];
                        var w = parseInt((bits[1] || '0').replace(/[^0-9]/g, ''), 10) || 0;
                        if (url && w >= bestW) { best = url; bestW = w; }
                    });
                    if (best) return best;
                }
                return img.currentSrc || img.src;
            }
            function captionFor(img) {
                if (img.getAttribute('alt')) return img.getAttribute('alt');
                var fig = img.closest('figure');
                if (fig) {
                    var cap = fig.querySelector('figcaption');
                    if (cap) return cap.textContent.trim();
                }
                return '';
            }

            // Build overlay
            var lb = document.createElement('div');
            lb.className = 'lightbox';
            lb.setAttribute('role', 'dialog');
            lb.setAttribute('aria-modal', 'true');
            lb.setAttribute('aria-label', 'Photo viewer');
            lb.innerHTML =
                '<div class="lightbox-counter" aria-hidden="true"></div>' +
                '<button class="lightbox-btn lightbox-close" aria-label="Close">×</button>' +
                '<button class="lightbox-btn lightbox-prev" aria-label="Previous photo">‹</button>' +
                '<div class="lightbox-img-wrap"><img class="lightbox-img" alt="" /></div>' +
                '<button class="lightbox-btn lightbox-next" aria-label="Next photo">›</button>' +
                '<div class="lightbox-caption"></div>';
            document.body.appendChild(lb);

            var lbImg = lb.querySelector('.lightbox-img');
            var lbCap = lb.querySelector('.lightbox-caption');
            var lbCount = lb.querySelector('.lightbox-counter');
            var btnPrev = lb.querySelector('.lightbox-prev');
            var btnNext = lb.querySelector('.lightbox-next');
            var btnClose = lb.querySelector('.lightbox-close');
            var current = 0;

            function render() {
                var img = photos[current];
                lbImg.src = fullSrc(img);
                lbImg.alt = img.getAttribute('alt') || '';
                var cap = captionFor(img);
                lbCap.textContent = cap;
                lbCap.style.display = cap ? '' : 'none';
                lbCount.textContent = (current + 1) + ' / ' + photos.length;
                lbCount.style.display = photos.length > 1 ? '' : 'none';
                btnPrev.disabled = current === 0;
                btnNext.disabled = current === photos.length - 1;
                btnPrev.style.display = photos.length > 1 ? '' : 'none';
                btnNext.style.display = photos.length > 1 ? '' : 'none';
            }
            function open(i) {
                current = i;
                render();
                lb.classList.add('is-open');
                document.body.classList.add('lightbox-open');
            }
            function close() {
                lb.classList.remove('is-open');
                document.body.classList.remove('lightbox-open');
            }
            function next() {
                if (current < photos.length - 1) { current++; render(); }
            }
            function prev() {
                if (current > 0) { current--; render(); }
            }

            photos.forEach(function (img, i) {
                img.addEventListener('click', function (e) {
                    e.preventDefault();
                    open(i);
                });
            });
            btnClose.addEventListener('click', close);
            btnPrev.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
            btnNext.addEventListener('click', function (e) { e.stopPropagation(); next(); });
            lb.addEventListener('click', function (e) {
                // Click on backdrop (not the image or a button) closes.
                if (e.target === lb || e.target.classList.contains('lightbox-img-wrap')) close();
            });
            document.addEventListener('keydown', function (e) {
                if (!lb.classList.contains('is-open')) return;
                if (e.key === 'Escape') close();
                else if (e.key === 'ArrowRight') next();
                else if (e.key === 'ArrowLeft') prev();
            });
        }

        // ── 6. 404 editorial note rotation ─────────────────────────────
        var noteRoot = document.getElementById('nf-note');
        if (noteRoot) {
            var notes = noteRoot.querySelectorAll('em[data-note]');
            if (notes.length) {
                notes.forEach(function (n) { n.hidden = true; });
                var pick = notes[Math.floor(Math.random() * notes.length)];
                pick.hidden = false;
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
